import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const PIXEL_ID = "1818171242497859";
const CONSENT_KEY = "pv_consent";
const ATTR_KEY = "pv_attribution";

export const API_BASE = API;

export const getConsent = () => {
  try {
    return JSON.parse(localStorage.getItem(CONSENT_KEY));
  } catch {
    return null;
  }
};

let pixelLoaded = false;

export const initPixel = () => {
  if (pixelLoaded || typeof window === "undefined") return;
  /* eslint-disable */
  !(function (f, b, e, v, n, t, s) {
    if (f.fbq) return;
    n = f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = !0;
    n.version = "2.0";
    n.queue = [];
    t = b.createElement(e);
    t.async = !0;
    t.src = v;
    s = b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t, s);
  })(window, document, "script", "https://connect.facebook.net/en_US/fbevents.js");
  /* eslint-enable */
  window.fbq("init", PIXEL_ID);
  pixelLoaded = true;
};

export const saveConsent = (marketing) => {
  localStorage.setItem(
    CONSENT_KEY,
    JSON.stringify({ necessary: true, marketing, ts: Date.now() })
  );
  if (marketing) {
    initPixel();
    track("PageView", { page: window.location.pathname });
  }
  window.dispatchEvent(new Event("pv-consent-changed"));
};

export const captureAttribution = () => {
  const p = new URLSearchParams(window.location.search);
  const keys = [
    "utm_source",
    "utm_medium",
    "utm_campaign",
    "utm_term",
    "utm_content",
    "fbclid",
    "ad_id",
    "adset_id",
    "campaign_id",
  ];
  const found = {};
  keys.forEach((k) => {
    const v = p.get(k);
    if (v) found[k] = v;
  });
  if (Object.keys(found).length) {
    found.landing_url = window.location.href;
    found.referrer = document.referrer || "";
    localStorage.setItem(ATTR_KEY, JSON.stringify(found));
  } else if (!localStorage.getItem(ATTR_KEY)) {
    localStorage.setItem(
      ATTR_KEY,
      JSON.stringify({ landing_url: window.location.href, referrer: document.referrer || "" })
    );
  }
};

export const getAttribution = () => {
  try {
    return JSON.parse(localStorage.getItem(ATTR_KEY)) || {};
  } catch {
    return {};
  }
};

const getCookie = (name) => {
  const m = document.cookie.match(new RegExp(`(?:^|; )${name}=([^;]+)`));
  return m ? m[1] : undefined;
};

export const getFbp = () => getCookie("_fbp");

export const getFbc = () => {
  const c = getCookie("_fbc");
  if (c) return c;
  const a = getAttribution();
  if (a && a.fbclid) return `fb.1.${Date.now()}.${a.fbclid}`;
  return undefined;
};

const STANDARD_EVENTS = ["PageView", "ViewContent", "Lead"];

export const newEventId = () =>
  window.crypto && window.crypto.randomUUID
    ? window.crypto.randomUUID()
    : `ev-${Date.now()}-${Math.random().toString(36).slice(2)}`;

export const track = (eventName, customData = {}) => {
  const consent = getConsent();
  if (!consent || !consent.marketing) return null;
  const eventId = newEventId();
  if (window.fbq) {
    if (STANDARD_EVENTS.includes(eventName)) {
      window.fbq("track", eventName, customData, { eventID: eventId });
    } else {
      window.fbq("trackCustom", eventName, customData, { eventID: eventId });
    }
  }
  axios
    .post(`${API}/track`, {
      event_name: eventName,
      event_id: eventId,
      event_source_url: window.location.href,
      fbp: getFbp(),
      fbc: getFbc(),
      custom_data: customData,
      attribution: getAttribution(),
    })
    .catch(() => {});
  return eventId;
};

export const trackOncePerSession = (key, eventName, customData = {}) => {
  if (sessionStorage.getItem(key)) return;
  sessionStorage.setItem(key, "1");
  track(eventName, customData);
};
